import { Button } from '@mui/material';
import Model from '../models/model';
import strings from '../Globalization';
import { useGridBase } from '../components/grid/GridBaseContext';
import { valueRenderr } from './ModelTable';

const SelectBtn = ({ row }) => {
	const { rowSelectionModel, onRowSelectionModel } = useGridBase();
	const handleOnClick = () => {
		rowSelectionModel.ids = new Set(row._id);
		onRowSelectionModel(rowSelectionModel);
	}
	return (
		<Button
			variant="contained"
			color="primary"
			size="small"
			disabled={rowSelectionModel._id === row.id}
			onClick={handleOnClick}
		>
			{strings.ResyncSelect}
		</Button>
	);
};
const model = new Model({
	name: 'EndoProfile',
	defaultSort: 'ClientName',
	idProperty: '_id',
	pageSize: 5,
	filter: [{ operator: '$eq', value: true, property: 'Endo', type: 'boolean' }],
	disableAdd: true,
	disablePreferences: true,
	disableExport: true,
	columns: [
		{ header: 'ClientName', field: 'ClientName', width: 150 },
		{ header: 'ModalName', field: 'ModelName', width: 150  },
		{ header: 'EquipmentType', field: 'DeviceType', width: 150, renderCell: ({ colDef, value }) => valueRenderr(colDef, value, 'ModelDeviceType') ,lookup: 'ModelDeviceType'},
		{ header: 'EquipmentName', field: 'EquipmentName', width: 150 },
		{ header: 'Serial#', field: 'SerialNumber', width: 150 },
		{ header: 'LocationName', field: 'LocationId', width: 150 ,lookup: 'Location',renderCell: ({ colDef, value }) => valueRenderr(colDef, value, 'Location') },
		{ field: 'ClearAllResync', header: 'ClearAllResync', width: 120, filterable: false, renderCell: SelectBtn }
	]
});
export const DeleteResyncDataModel = model;

export default model.createFormBase();

